const validToothSurface = [ 'M', 'O', 'I', 'D', 'B', 'L', 'V' ];
const validToothSurfaceSet = new Set(validToothSurface);

/**
 *
 * @param toothNumber
 * @returns {null|string}
 */
function validateToothNumber(toothNumber) {
    // ToothNumber is null in Pending EDI Claims if it was not set by the dentist.
    if (toothNumber === null) {
        return null;
    }

    if (typeof toothNumber !== 'string') {
        return 'Tooth Number must be a string.';
    }

    const regex = /^([0-9]{1,2})?$/;
    if (!regex.test(toothNumber) || toothNumber.trim() === '0' || toothNumber.trim() === '00') {
        return 'Invalid Tooth Number Provided';
    }

    return null;
}

/**
 *
 * @param toothSurface
 * @returns {null|string}
 */
function validateToothSurface(toothSurface) {
    if (typeof toothSurface !== 'string') {
        return 'Tooth Surface must be a string.';
    }

    if (toothSurface.length > 5) {
        return 'Invalid number of Tooth Surface codes provided.';
    }

    const validToothSurfaceSplit = toothSurface.split('');

    // Check all surfaces provided are valid
    if (!validToothSurfaceSplit.every((e) => validToothSurfaceSet.has(e))) {
        return 'Invalid Tooth Surface code provided.';
    }

    // Check that there are no duplicates
    const providedToothSurfaceLength = validToothSurfaceSplit.length;
    const toothSurfaceDuplicatesRemovedLength = [ ...new Set(validToothSurfaceSplit) ].length;

    if (providedToothSurfaceLength !== toothSurfaceDuplicatesRemovedLength) {
        return 'Duplicate Tooth Surface code provided.';
    }

    return null;
}

/**
 *
 * @param birthdate
 * @returns {null|string}
 */
function validateBirthdate(birthdate) {
    if (typeof birthdate !== 'string') {
        return 'Birthdate must be a string.';
    }

    if (birthdate.trim().length === 0) {
        return 'Birthdate cannot be empty.';
    }

    const now = Math.floor(Date.now() / 1000);
    const birthdateTimestamp = Math.floor(new Date(birthdate).getTime() / 1000);

    // Check birthdate is not in the future
    if (birthdateTimestamp > now) {
        return 'Birthdate cannot be in the future.';
    }

    const diff = now - birthdateTimestamp;
    const yearsAgo150InSeconds = 150 * 365 * 24 * 60 * 60;

    // Verify that the date is within the last 150 years.
    if (diff > yearsAgo150InSeconds) {
        return 'Birthdate must be within the last 150 years.';
    }

    return null;
}

/**
 *
 * @param firstName
 * @returns {null|string}
 */
function validateFirstName(firstName) {
    if (typeof firstName !== 'string') {
        return 'Firstname must be a string.';
    }

    if (firstName.trim().length === 0) {
        return 'Firstname cannot be empty.';
    }

    if (firstName.trim() === '0') {
        return 'Firstname cannot be "0".';
    }

    return null;
}

/**
 *
 * @param lastName
 * @returns {null|string}
 */
function validateLastName(lastName) {
    if (typeof lastName !== 'string') {
        return 'Lastname must be a string.';
    }

    if (lastName.trim().length === 0) {
        return 'Lastname cannot be empty.';
    }

    if (lastName.trim() === '0') {
        return 'Lastname cannot be "0".';
    }

    return null;
}

/**
 *
 * @param policyNumber
 * @returns {null|string}
 */
function validatePolicyNumber(policyNumber) {
    if (typeof policyNumber !== 'string') {
        return 'Policy Number must be a string.';
    }

    if (policyNumber.length > 12) {
        return 'Policy Number must be less than 12 characters.';
    }

    const policyNumberTrimmed = policyNumber.trim();

    if (policyNumberTrimmed.length === 0) {
        return 'Policy Number cannot be empty.';
    }

    if (policyNumberTrimmed === '0') {
        return 'Policy Number cannot be "0".';
    }

    const regex = /^[a-zA-Z0-9]{1,12}$/;
    if (!regex.test(policyNumberTrimmed)) {
        return 'Policy Number format is invalid.';
    }

    return null;
}

/**
 *
 * @param cert
 * @returns {null|string}
 */
function validateCertificate(cert) {
    if (typeof cert !== 'string') {
        return 'Certificate must be a string.';
    }

    if (cert.length > 12) {
        return 'Certificate must be less than 12 characters.';
    }

    const certTrimmed = cert.trim();

    if (certTrimmed.length === 0) {
        return 'Certificate cannot be empty.';
    }

    if (certTrimmed === '0') {
        return 'Certificate cannot be "0".';
    }

    const regex = /^[0-9]{1,12}$/;
    if (!regex.test(certTrimmed)) {
        return 'Certificate format is invalid.';
    }

    return null;
}

export {
    validToothSurface,
    validateToothSurface,
    validateToothNumber,
    validateBirthdate,
    validateFirstName,
    validateLastName,
    validatePolicyNumber,
    validateCertificate
};